import { Injectable, OnDestroy } from '@angular/core';
import io from 'socket.io-client';
import { StorageService } from 'src/app/core/services/storage.service';
import { UserService } from 'src/app/shared/services/user.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SocketService implements OnDestroy {
  private socket: any | null = null;

  private isConnected = false;

  constructor(
    private storageService: StorageService,
    private userService: UserService
  ) {}

  connect(): any | null {
    // If already connected or connecting, return existing socket
    if (this.socket && this.isConnected) {
      return this.socket;
    }

    const user = this.storageService.getUser();
    const token = this.storageService.getAccessToken();

    if (!user || !token) {
      return null;
    }

    const userId = user.profile?._id;
    const hospitalId = this.userService.getSelectedHospitals()[0];

    this.socket = io(environment.socketEndPoint, {
      auth: { token },
      query: {
        profile: userId,
        hospital: hospitalId,
      },
      transports: ['websocket', 'polling'],
    });

    return this.socket;
  }

  getSocket(): any | null {
    return this.socket;
  }

  disconnect(): void {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
      this.isConnected = false;
    }
  }

  ngOnDestroy(): void {
    this.disconnect();
  }
}
